import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var TemplatePipe = (function () {
    function TemplatePipe() {
    }
    TemplatePipe.prototype.transform = function (input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!isString(input) || args.length === 0) {
            return input;
        }
        var template = input;
        for (var i = 0; i < args.length; ++i) {
            template = template.replace("$" + (i + 1), args[i]);
        }
        return template;
    };
    return TemplatePipe;
}());
export { TemplatePipe };
TemplatePipe.decorators = [
    { type: Pipe, args: [{
                name: 'template'
            },] },
];
/** @nocollapse */
TemplatePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=template.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/template.pipe.js
// module id = 291
// module chunks = 103